<template>
  <div class="principal-guia-etapas">
    <ul class="lista-rol">
      <li>
        Embajador
      </li>
      <li>
        Embajador
      </li>
      <li>
        Embajador
      </li>
      <li>
        Prospecto
      </li>
      <li>
        HIR Casa
      </li>
      <li>
        Prospecto
      </li>
      <li>
        Prospecto
      </li>
    </ul>
    <ul class="progressbar">
      <li class="active">
        Crea el prospecto
      </li>
      <li class="active">
        Agenda una llamada
      </li>
      <li class="active">
        Agenda una cita o videollamada
      </li>
      <li class="active">
        Integración de expediente
      </li>
      <li class="active">
        Pre-autorización
      </li>
      <li class="active">
        Pago de cuota de inscripción
      </li>
      <li class="active">
        Bienvenido a HIR Casa
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
$color-primario: #b8725a;
$poppins: "Poppins";
$gris-deshabilitado: #bcbcbc;

.lista-rol > li {
  display: inline-block;
  list-style-type: none;
  width: 14%;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
}
.progressbar {
  counter-reset: step;
}
.progressbar li {
  list-style-type: none;
  width: 14%;
  font-size: 16px;
  position: relative;
  text-align: center;
  text-transform: capitalize;
  font-family: $poppins;
  font-weight: 700;
  color: $color-primario;
  float: left;
}
.progressbar li:before {
  content: "";
  counter-increment: step;
  width: 15px;
  height: 15px;
  border: 4px solid $color-primario;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}
.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 3px;
  background: $color-primario;
  top: 7px;
  left: -50%;
  z-index: -1;
}
.progressbar li:first-child:after {
  content: none;
}
@media all and (max-width: 767px) {
  .principal-stepper {
    display: none;
  }
}
</style>
